// Module
var code = "<abx-detail-header abx-building=\"vm.building\" abx-heading=\"vm.schedule.display_number + ' | ' + vm.schedule.subject\" abx-model=\"vm.schedule\" abx-model-type=\"schedule\" abx-subtitle=\"vm.subtitle\" abx-tabs=\"vm.tabs\"> </abx-detail-header> <div ui-view flex layout=\"column\" class=\"scroll-y\"></div> ";
// Exports
module.exports = code;